import { floatToFixed2 } from '@/utils'

// 格式化金额【分转元】；空值 / 历史占位负数显示 —
// @ts-ignore
export const fenToYuanFormat = (_, __, cellValue: any, ___) => {
  if (cellValue === null || cellValue === undefined || cellValue === '' || Number(cellValue) < 0) {
    return '—'
  }
  const text = floatToFixed2(cellValue)
  return text === '' ? '—' : `￥${text}`
}
